import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/find-and-fix/')({
    beforeLoad: () => {
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw redirect({ to: '/find-and-fix/network-overview' });
    },
});
